import { Link } from "../../molecules/Link";

export const IdiomaSidebar = (props) => {
  return (
    <nav
      id="sidebar"
      className="flex flex-col min-w-[13rem] min-h-screen bg-theme-blue text-white"
    >
      <Link route={"/idiomas"}>{"Lista de idiomas"} </Link>
      <Link route={"/idiomas/registrar"}>{"Agregar idiomas"} </Link>
      <Link route={"/idiomas/VerModulos"}>{"Lista de Módulos"} </Link>
      <Link route={"/modulos/registrar"}>{"Agregar modulos"} </Link>
    </nav>
  );
};
